import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Countdown from "@/components/site/Countdown";
import Story from "@/components/site/Story";
import Scripture from "@/components/site/Scripture";
import Marquee from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import FreeGift from "@/components/site/FreeGift";
import Author from "@/components/site/Author";
import ReviewCTA from "@/components/site/ReviewCTA";
import Book2Teaser from "@/components/site/Book2Teaser";
import SpreadTheWord from "@/components/site/SpreadTheWord";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="relative min-h-screen bg-twilight text-cream" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Countdown />
        <Story />
        <Scripture />
        <Marquee />
        <Gallery />
        <FreeGift />
        <Author />
        <ReviewCTA />
        <Book2Teaser />
        <SpreadTheWord />
      </main>
      <Footer />
    </div>
  );
}
